import { render, staticRenderFns } from "./store_switcher.vue?vue&type=template&id=b3a1bdd4&scoped=true"
import script from "./store_switcher.vue?vue&type=script&lang=js"
export * from "./store_switcher.vue?vue&type=script&lang=js"
import style0 from "./store_switcher.vue?vue&type=style&index=0&id=b3a1bdd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3a1bdd4",
  null
  
)

export default component.exports